import React, { useMemo } from 'react';

import { type EmailMessagesFilterInput } from '@dashboard/generated/wp/platform';
import { useIsMediaQuery } from '@dashboard/hooks/media-queries';
import { Paper, Tab, Tabs, Typography } from '@mui/material';

import ReportBarMetric from './ReportBar/ReportBarMetric';

type Props = {
  filter: EmailMessagesFilterInput;
  setFilter: (value: EmailMessagesFilterInput) => void;
};

function InternalFiltersBar({ filter, setFilter }: Props) {
  const reportBarFilter = useMemo(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { eventType, ...filterRest } = filter;
    return filterRest;
  }, [filter]);
  const isTablet = useIsMediaQuery('md');
  const reportsBarVariant = isTablet ? 'fullWidth' : 'scrollable';

  return (
    <Tabs
      value={filter.eventType}
      onChange={(_, val) => setFilter({ eventType: val })}
      variant={reportsBarVariant}
      scrollButtons={false}
      sx={{
        justifyContent: 'space-between',
        borderBottom: '1px solid',
        borderBottomColor: 'divider',
        '& .MuiStack-root': { width: '100%', minWidth: 96, justifyContent: 'center' },
        '& .MuiTabs-flexContainer': {
          justifyContent: 'space-between',
        },
      }}
    >
      <Tab value="ALL" label={<ReportBarMetric filter={reportBarFilter} template="ALL" />} />
      <Tab value="DELIVERED" label={<ReportBarMetric filter={reportBarFilter} template="DELIVERED" />} />
      <Tab value="OPENED" label={<ReportBarMetric filter={reportBarFilter} template="OPENED" />} />
      <Tab value="CLICKED" label={<ReportBarMetric filter={reportBarFilter} template="CLICKED" />} />
      <Tab value="BOUNCED" label={<ReportBarMetric filter={reportBarFilter} template="BOUNCED" />} />
      <Tab value="COMPLAINED" label={<ReportBarMetric filter={reportBarFilter} template="COMPLAINED" />} />
      <Tab value="SUPPRESSED" label={<ReportBarMetric filter={reportBarFilter} template="SUPPRESSED" />} />
      <Tab value="UNSUBSCRIBED" label={<ReportBarMetric filter={reportBarFilter} template="UNSUBSCRIBED" />} />
      <Tab value="ERRORED" label={<ReportBarMetric filter={reportBarFilter} template="ERRORED" />} />
    </Tabs>
  );
}

type ErrorBoundaryState = {
  hasError: boolean;
};
export default class FiltersBar extends React.Component<Props, ErrorBoundaryState> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <Paper>
          <Typography>There was an error loading the filters</Typography>
        </Paper>
      );
    }

    return (
      <Paper>
        <InternalFiltersBar {...this.props} />
      </Paper>
    );
  }
}
